<template>
  <div class="px-4">
    <v-row>
      <template v-for="(form, idx) of searchInfo">
        <v-col
          xs12
          md6
          lg4
          xl3
          :key="`form-${idx}`">
          <label class="form-label">
            {{ form.text || form.key }}
          </label>
          <template
            v-if="form.type === 'client'">
            <ClientSelector
              :id="form.key"
              v-model="search[idx]"
              />
          </template>
          <template
            v-else-if="form.type === 'status'">
            <Status
              :id="form.key"
              v-model="search[idx]"
              />
          </template>
          <template
            v-else>
            <v-text-field
              :id="form.key"
              v-model="search[idx]"
              dense
              solo
              flat
              outlined
              hide-details>
            </v-text-field>
          </template>
        </v-col>
      </template>
    </v-row>
    <v-row>
      <v-col
        class="d-flex">
        <v-btn
          color="error"
          class="mr-2 ml-auto"
          depressed
          @click="onReset">
          <v-icon left>mdi-close</v-icon>
          취소
        </v-btn>
        <v-btn
          color="primary"
          depressed
          @click="onSearch">
          <v-icon left>mdi-magnify</v-icon>
          검색
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { STORE } from '@/constants'

import Status from '@/components/fields/Status'
import ClientSelector from '@/components/fields/Client'

export default {
  components: {
    Status,
    ClientSelector
  },

  computed: {
    ...mapGetters({
      objInfo: `${STORE.ADMIN.NAME}/${STORE.ADMIN.OBJ_INFO}`
    }),

    searchInfo () {
      return this.objInfo.search || {}
    },

    count () {
      return this.objInfo.search.length
    }
  },

  watch: {
    searchInfo (val) {
      if (!val) {
        return false
      }

      this.search = new Array(val.length).fill(null)
    }
  },

  data: () => ({
    search: []
  }),

  methods: {
    onSearch () {
      const search = {}

      this.searchInfo.forEach((v, idx) => {
        search[v.key] = this.search[idx]
      })

      this.$emit('search', search)
    },

    onReset () {
      this.search = new Array(this.searchInfo.length).fill(null)
      this.$emit('reset')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SearchForm.vue